import React, { ReactNode } from 'react';

import { ActionIcon, type ActionIconProps } from '../../Buttons/ActionIcon/ActionIcon';
import { IconDownload } from '../../Icons';
import { Tooltip } from '../../Overlays/Tooltip/Tooltip';

interface Props extends ActionIconProps {
  onClick?: (e: React.MouseEvent) => void;
  title?: ReactNode | string;
}

const ExportButton = ({ onClick, title = 'Export to CSV', loading, ...props }: Props) => {
  return (
    <Tooltip
      label={title}
      maw={115}
      styles={{ tooltip: { display: 'flex', justifyContent: 'center' } }}
    >
      <ActionIcon
        variant="outline"
        color="cobalt"
        onClick={loading ? undefined : onClick}
        loading={loading}
        style={{ borderWidth: 2, flexShrink: 0 }}
        size="md"
        {...props}
      >
        <IconDownload brand="tabler" />
      </ActionIcon>
    </Tooltip>
  );
};

export { ExportButton };
